import { Injectable, inject, signal } from '@angular/core';
import { ToastStore } from '@/features/toast-store.service';

export interface CurveRetrievedEvent {
  readonly opportunityId: string;
  readonly receivedAt: number;
}

@Injectable({ providedIn: 'root' })
export class RealtimeNotificationStore {
  private readonly toastStore = inject(ToastStore);

  private readonly _curveRetrieved = signal<CurveRetrievedEvent | null>(null);

  public readonly curveRetrieved = this._curveRetrieved.asReadonly();

  handleCurveRetrieved(opportunityId: string): void {
    this._curveRetrieved.set({ opportunityId, receivedAt: Date.now() });
    this.toastStore.show({ type: 'INFO', title: 'notifications.curveRetrieved.title' });
  }
}
